import { createAction, props } from '@ngrx/store';
import { NewsDetails } from '@fc-core/models/news-details.model';

export const loadNews = createAction('[News] Load News');

export const loadNewsSuccess = createAction(
  '[News] Load News Success',
  props<{ data: NewsDetails[] }>(),
);

export const setShowNews = createAction(
  '[News] Set Show News',
  props<{ showNewsState: number }>(),
);

export const loadNewsFailure = createAction(
  '[News] Load News Failure',
  props<{ error: any }>(),
);
